<template>
  <section class="sec_home-trouble">
    <PartsHomeTitle title="お悩みを診断してみよう" subtitle="悩み別に見つけるわたしのアイテム" />

    <div class="trouble-tabs" role="tablist" aria-label="お悩みの種類">
      <button
        v-for="tab in TROUBLE_TABS"
        :id="`trouble-tab-${tab.id}`"
        :key="tab.id"
        type="button"
        role="tab"
        class="trouble-tab-btn"
        :class="{ 'is-active': tab.id === activePanelId }"
        :aria-selected="tab.id === activePanelId"
        :aria-controls="`trouble-panel-${tab.id}`"
        @click="activePanelId = tab.id"
      >
        <div class="trouble-tab_icon" :class="tab.iconModifier">
          <img class="icon-on" :src="tabIconUrl(tab.iconName, 'wh')" alt="" />
          <img class="icon-off" :src="tabIconUrl(tab.iconName, 'green')" alt="" />
        </div>
        <!-- eslint-disable-next-line vue/no-v-html -- 定数リテラルの `<br class="sp-only">` のみ。外部入力は通さない -->
        <span v-html="tab.label"></span>
      </button>
    </div>

    <div
      v-for="tab in TROUBLE_TABS"
      :id="`trouble-panel-${tab.id}`"
      :key="tab.id"
      role="tabpanel"
      :aria-labelledby="`trouble-tab-${tab.id}`"
      :hidden="tab.id !== activePanelId"
      class="trouble-card"
      :class="{ 'is-active': tab.id === activePanelId }"
    >
        <PartsTroubleCard v-for="card in cardsOf(tab.id)" :key="card.icon" :card="card" />
    </div>

    <PartsBtnRound to="/trouble" label="すべてのお悩みを見る" />
  </section>
</template>

<script setup lang="ts">
/**
 * 支給デザインの `sec_home-trouble`（お悩みを診断してみよう）。
 *
 * 支給の切り替えは `is-active` クラスの付け外しだけで、表示/非表示は支給CSSが持つ
 * （`.trouble-card { display: none }` → `.trouble-card.is-active { display: grid }`）。
 * したがって **`v-show` は使えない** — インラインの `display: none` が支給CSSの `display: grid` を潰す。
 * `is-active` のバインドで再現し、非アクティブ側には支援技術向けに `hidden` を足す（§3.6-3）。
 *
 * タブアイコンの on/off も支給CSSが `.is-active` 配下で `display` を入れ替えるので、
 * `icon-on` / `icon-off` の2枚 img 構造は崩さない。
 */
import type { TroubleCard, TroublePanelId } from '@/types/domains/TroubleType';
import { TROUBLE_CARDS, TROUBLE_TABS } from '@/consts/TroubleConst';

const activePanelId = ref<TroublePanelId>(TROUBLE_TABS[0].id);

const cardsOf = (panel: TroublePanelId): TroubleCard[] =>
  TROUBLE_CARDS.filter((card) => card.panel === panel);

const tabIconUrl = (iconName: string, state: 'wh' | 'green'): string =>
  `/image/trouble-icon_${iconName}_${state}.png`;
</script>
